import {useState} from 'react'
import {Switch} from 'antd'

import styles from './RequestApproveForm.module.scss'
import {useCreateProjectConditions} from 'modules/project'
import {Box, Button, Text, Modal} from 'common/components'
import {useOpen} from 'common/hooks'
import {ApprovalConditions, PushBackForm, useAcceptRequestStatus} from '..'

interface RequestApproveFormProps {
  request: any
  onClose: () => void
}

interface PushBackProps {
  requestUuid: string
}

export default function RequestApproveForm({
  request,
  onClose,
}: RequestApproveFormProps) {
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid, onClose)
  const {
    mutate: createProjectConditions,
    isMutating: isCreateProjectConditionsMutating,
  } = useCreateProjectConditions(
    request.project.uuid,
    request.uuid,
    acceptRequestStatus
  )
  const [isConditions, setIsConditions] = useState(false)
  const [conditions, setConditions] = useState<any[]>([])

  const handleApprove = () => {
    if (isConditions) return createProjectConditions(conditions)
    acceptRequestStatus()
  }

  return (
    <div className={styles.root}>
      <Box mb={24} pt={8}>
        <div className={styles.switch}>
          <Text weight="demiBold">Are there any conditions for approval?</Text>
          <Switch checked={isConditions} onChange={setIsConditions} />
        </div>
      </Box>
      {isConditions && (
        <ApprovalConditions
          request={request}
          conditions={conditions}
          setConditions={setConditions}
        />
      )}
      <Button
        block
        loading={
          isAcceptRequestStatusMutating || isCreateProjectConditionsMutating
        }
        disabled={isConditions && !conditions.length}
        onClick={handleApprove}
      >
        Approve loan request{isConditions && ' with conditions'}
      </Button>
      <Box mt={16}>
        <Text size="xs" color="grey" mb={12}>
          If you do not have enough data to make a decision, you can send a
          request to the Lending manager to clarify the necessary information.
        </Text>
        <PushBack requestUuid={request.uuid} />
      </Box>
    </div>
  )
}

const PushBack = ({requestUuid}: PushBackProps) => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  return (
    <>
      <Button variant="danger" onClick={handleOpen}>
        push back to lending manager
      </Button>
      <Modal
        title="Back to Lending Manager"
        open={isOpen}
        onCancel={handleClose}
      >
        <PushBackForm requestUuid={requestUuid} onClose={handleClose} />
      </Modal>
    </>
  )
}
